export const customColumns = [
	'rownum',
	'fileThumb',
	'rowSelection',
	'workflow',
	'query',
	'virtual',
];

/**
 * @param {string} formatter
 * @returns {boolean}
 */
export const isCustomColumn = formatter => customColumns.includes(formatter);
